import { render } from "./CustomerManagement.vue?vue&type=template&id=1806696a&scoped=true"
import script from "./CustomerManagement.vue?vue&type=script&lang=js"
export * from "./CustomerManagement.vue?vue&type=script&lang=js"

import "./CustomerManagement.vue?vue&type=style&index=0&id=1806696a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1806696a"]])

export default __exports__